// extracted by mini-css-extract-plugin
module.exports = {"subtitle":"style_subtitle__3H1lC"};